import React, { FC, ReactNode } from 'react'
import { ClockCircleTwoTone, InfoCircleTwoTone } from '@ant-design/icons'
import Tooltip from '../Tooltip/Tooltip'
import styles from './VerticalTopBarStatistics.module.scss'

interface IData {
  label: string
  value: string | ReactNode | ReactNode[]
  tooltipText?: string
  tooltipHeader?: string
  comingSoon?: boolean
}

interface IVerticalTopBarStatistics {
  data: IData[]
}

const VerticalTopBarStatistics: FC<IVerticalTopBarStatistics> = ({ data }) => {
  return (
    <div className={styles.container}>
      {data.map((item, i) => (
        <div key={i} className={styles.item}>
          {item.tooltipText ? (
            <Tooltip className={styles.tooltip} title={item.tooltipText} header={item.tooltipHeader}>
              <div className={styles.label}>{item.label}</div>
              <InfoCircleTwoTone twoToneColor='#BFBFBF' className={styles.icon} />
            </Tooltip>
          ) : (
            <div className={styles.label}>{item.label}</div>
          )}
          {item.comingSoon ? (
            <div className={styles.comingSoon}>
              <ClockCircleTwoTone />
              <span>COMING SOON</span>
            </div>
          ) : (
            <div className={styles.value}>{item.value}</div>
          )}
        </div>
      ))}
    </div>
  )
}

export default VerticalTopBarStatistics
